import script from "./surveyEnd.vue?vue&type=script&setup=true&lang=js"
export * from "./surveyEnd.vue?vue&type=script&setup=true&lang=js"

import "./surveyEnd.vue?vue&type=style&index=0&id=1082e4aa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1082e4aa"]])

export default __exports__